import type { ReactNode } from "react";
import { Icon } from "@/components/Icon/Icon";

type Props = {
  pending: boolean;
  disabled?: boolean;
  pendingLabel: string;
  children: ReactNode;
};

export function SubmitButton({ pending, disabled, pendingLabel, children }: Props) {
  return (
    <button type="submit" className="signin-submit" disabled={disabled || pending}>
      {pending ? (
        <>
          <span className="shimmer" style={{ width: 12, height: 12, borderRadius: 6 }} />
          {pendingLabel}
        </>
      ) : (
        <>
          {children}
          <Icon name="arrow-r" size={14} />
        </>
      )}
    </button>
  );
}
